import styled from 'styled-components';
import BaseCoreProperties from '@prisjakt/ui-core-properties';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { media } from '@prisjakt/ui-base';

export const StyledCoreProperties = styled(BaseCoreProperties)`
  && {
    color: inherit;
    margin: 0;
  }
`;

export const TabSubtitle = styled(CaptionText)`
  flex: 0 0 100%;
  transition: all 0.1s linear;
  display: flex;
  align-items: center;
  height: 1.75em;

  ${media.smallOnly`
    display: none;
  `}
`;
